import Layout from "@/layout";

const administratorRouter = {
  path: "/administrator",
  component: Layout,
  redirect: "/administrator/index",
  name: "administrator",
  children: [
    {
      path: "index",
      component: () => import("@/views/administrator/index.vue"),
      name: "UserIndex",
      meta: { title: "管理员管理", icon: "" }
    }
  ]
};

export default administratorRouter;
